import { createFileRoute } from '@tanstack/react-router';
import { EditorPage } from '../pages/editor';

export const Route = createFileRoute('/editor' as any)({
  component: EditorPage,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      projectId: (search.projectId as string) || '',
      filePath: (search.filePath as string) || '',
      type: (search.type as 'github' | 'local') || 'local',
      branch: (search.branch as string) || 'main'
    };
  }
});
